import { Grid } from '@mui/material';

import { RoutalPalette } from '@nx-smartmonkey/ui';
import Background from '../../assets/img/onboarding/backgrounds/background_auth.png';
import RoutalLogo from '../../assets/img/routal-logo.svg';
import RoutalStarGreen from '../../assets/img/routal-star-green.svg';
import Text from '../../react-components/Text';
import { AuthContainer, AuthFooter, AuthHeader } from './Auth.styled';
import { Invitation } from './invitation';
import { Login } from './login';
import { Recovery } from './recovery';
import { Register } from './register';

type AuthProps = {
  route: `login` | `invitation` | `register` | `reset-password`;
};

export const Auth = ({ route }: AuthProps) => {
  return (
    <Grid container direction="row" wrap="nowrap">
      <AuthContainer
        container
        direction="column"
        wrap="nowrap"
        style={{ position: `relative`, minWidth: `360px`, maxWidth: `600px` }}
      >
        <AuthHeader item container justifyContent="flex-start" alignItems="flex-start" style={{ marginBottom: `20px` }}>
          <img width="145" src={RoutalLogo} alt="" />
          <img width="14" src={RoutalStarGreen} alt="" />
        </AuthHeader>

        {route === `login` && <Login />}
        {route === `register` && <Register />}
        {route === `reset-password` && <Recovery />}
        {route === `invitation` && <Invitation />}

        <AuthFooter />
      </AuthContainer>

      <Grid
        container
        item
        alignItems="center"
        justifyContent="center"
        style={{
          backgroundImage: `url(${Background})`,
          backgroundRepeat: `no-repeat`,
          backgroundSize: `cover`,
          width: `100%`,
          position: `relative`,
        }}
      >
        <Text
          variant="h3"
          intlId="auth.claim"
          style={{
            color: RoutalPalette.white,
            maxWidth: `60%`,
            textAlign: `center`,
            zIndex: 1,
          }}
        />
      </Grid>
    </Grid>
  );
};
